import React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import { MatField } from 'src/core/components/mat-field';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import * as styles from './application.less';

import { AddressForm } from '../../forms/application-information-forms';

interface IAddressProps {
    address: AddressForm;
    disabled: boolean;
    states: string[];
    validate: (fieldState: FieldState<string>) => () => Promise<void>;
}

export const Address: React.FC<IAddressProps> = observer(
    ({ address, validate, disabled = false, states }) => {
        return (
            <React.Fragment>
                <div className={styles.row}>
                    <MatField
                        required
                        fullWidth
                        errorColor
                        disabled={disabled}
                        fieldState={address.$.Street}
                        maxLength={100}
                        label="Home Street Address"
                        onBlur={validate(address.$.Street)}
                    />
                </div>
                <div className={styles.row}>
                    <MatField
                        fullWidth
                        errorColor
                        disabled={disabled}
                        fieldState={address.$.Unit}
                        maxLength={50}
                        label="Unit"
                    />
                </div>
                <div className={styles.row}>
                    <MatField
                        required
                        fullWidth
                        errorColor
                        disabled={disabled}
                        fieldState={address.$.City}
                        maxLength={100}
                        label="City"
                        onBlur={validate(address.$.City)}
                    />
                </div>
                <div className={styles.row}>
                    <FormControl required>
                        <InputLabel htmlFor="select">State</InputLabel>
                        <Select
                            inputProps={{ id: 'addressState' }}
                            value={address.$.State.value}
                            disabled={disabled}
                            onChange={async (e) => {
                                address.$.State.onChange(e.target.value as string);
                                await validate(address.$.State)();
                            }}
                        >
                            {states.map((value, index) => (
                                <MenuItem key={index} value={value}>
                                    {value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div className={styles.row}>
                    <MatField
                        required
                        fullWidth
                        errorColor
                        disabled={disabled}
                        fieldState={address.$.Zip}
                        maxLength={100}
                        label="Postal Code"
                        onBlur={validate(address.$.Zip)}
                    />
                </div>
            </React.Fragment>
        );
    }
);
